import Vue from 'vue'
import SvgIcon from '@/components/svgicon' // svg组件

// register globally
Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
// eslint-disable-next-line
const req = require.context('./', true, /\.svg$/)

requireAll(req)



// WEBPACK FOOTER //
// ./src/icons/index.js